import isMultipleSizes from "./isMultipleSizes";
import implyVariantFromSelections from "../implyVariantFromSelections";

export default ({
  isOneSize,
  isNoSize,
  selectedColourWayId,
  selectedVariantId,
  variants
}) => {
  if (selectedVariantId) return selectedVariantId;
  if (isMultipleSizes({ isOneSize, isNoSize })) return null;

  return implyVariantFromSelections({ selectedColourWayId, variants }).id;
};
